export default () => {
    const buttons = document.querySelectorAll('.text-link--read-more')
    const className = {
        isExpanded: 'is-expanded',
        isCollapsed: 'is-collapsed'
    }

    buttons?.forEach(button => {
        button.addEventListener('click', () => {
            const isExpanded = button.getAttribute('aria-expanded') === 'true';
            const container = document.getElementById(button.getAttribute('aria-controls'))

            if (!container) {
                return
            }

            const style = getComputedStyle(container)
            const collapsedHeight = style.getPropertyValue('--collapsed-height')
            const expandedHeight = `${container.scrollHeight}px`

            if (isExpanded) {
                button.setAttribute('aria-expanded', 'false');
                container.style.maxHeight = collapsedHeight;
                container.classList.remove(className.isExpanded);
                container.classList.add(className.isCollapsed);
                container.scrollIntoView();
            } else {
                button.setAttribute('aria-expanded', 'true');
                container.style.maxHeight = expandedHeight;
                container.classList.remove(className.isCollapsed);
                container.classList.add(className.isExpanded);
            }
        })
    })
}